import { render, staticRenderFns } from "./ReturnPartsRemarks.vue?vue&type=template&id=6eace794&scoped=true"
import script from "./ReturnPartsRemarks.vue?vue&type=script&lang=js"
export * from "./ReturnPartsRemarks.vue?vue&type=script&lang=js"
import style0 from "./ReturnPartsRemarks.vue?vue&type=style&index=0&id=6eace794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eace794",
  null
  
)

export default component.exports